<template>
  <div class="depSetting">
    <!-- 修改项目部弹窗-->
    <el-dialog
      title="设置水印"
      :visible.sync="isDialogShow"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form label-width="90px" ref="waterMarkForm" :rules="rules">
        <el-row v-for="(waterMarkItem, index) in waterMarkForm" :key="index">
          <el-col :span="3">
            <el-form-item label="水印内容：" v-if="index == 0">
              <!-- <el-input v-model="pwdForm.newPassword" autocomplete="off" type="password"></el-input> -->
            </el-form-item>
            <el-form-item label="" v-else>
              <!-- <el-input v-model="pwdForm.newPassword" autocomplete="off" type="password"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="19">
            <el-input v-model="waterMarkItem.value"></el-input>
          </el-col>
          <!-- <el-col :span="2" v-if="index === waterMarkForm.length - 1">
            <el-button
              icon="el-icon-plus"
              circle
              @click="addWaterMark()"
            ></el-button
          ></el-col>
          <el-col :span="2" v-if="waterMarkForm.length != 1">
            <el-button
              icon="el-icon-minus"
              circle
              @click="deleteWaterMark(index)"
            ></el-button
          ></el-col> -->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="isDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="savewaterMarkClick()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取合同填充内容
  createOrUpdateSubContractPrint,
} from "@/services/allContractServices";
export default {
  name: "depSetting",
  data() {
    return {
      isDialogShow: false,
      contractId: 0,
      waterMarkIdList: [],
      waterMarkForm: [
        {
          value: "",
        },
      ],
      userCode: "",
      rules: {
        waterMarkItem: [
          { required: true, message: "请输入水印内容", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    showwaterMarkDialog(contractId, val) {
      this.contractId = contractId;
      if (val.length >= 1) {
        this.waterMarkForm = [];
        val.forEach((ele) => {
          // let i = this.waterMarkIdList.findIndex(
          //   (item) => item.id == ele.waterMarkId
          // );
          let s = {};
          s.value = ele;
          this.waterMarkForm.push(s);
        });
      }

      this.isDialogShow = true;
    },

    // //获取已设置的项目部
    // getwaterMarkData() {
    //   querywaterMarkSetting().then((res) => {
    //     if (res.code == 10000000) {
    //       this.waterMarkForm = res.data;
    //     }
    //   });
    // },
    //添加一條水印
    addWaterMark() {
      this.waterMarkForm.push({ value: "" });
    },
    //刪除一條水印
    deleteWaterMark(index) {
      if (this.waterMarkForm.length > 1) this.waterMarkForm.splice(index, 1);
    },

    /* 修改 保存按钮回调 */
    savewaterMarkClick() {
      let s = [];

      this.waterMarkForm.forEach((ele) => {
        // let i = this.waterMarkIdList.findIndex(
        //   (item) => item.id == ele.waterMarkId
        // );
        // ele.waterMarkName = this.waterMarkIdList[i].name;
        // ele.viewIndex = ele.viewIndex;
        // ele.waterMarkId = ele.waterMarkId;
        s.push(ele.value);
      });

      if (this.contractId) {
        let param = {
          subContractId: this.contractId,
          watermark: s,
          // version: "1.0",
        };
        createOrUpdateSubContractPrint(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.$emit("setWaterMarkFun", s);
              this.$message.success("保存成功");
              this.isDialogShow = false;
            } else {
              this.$alert(res.msg, "确定");
            }
          })
          .catch((err) => {
            this.$message.error("网络请求失败");
          });
      } else {
        this.$emit("setWaterMarkFun", s);
        this.$message.success("保存成功");
        this.isDialogShow = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.depSetting {
  /deep/.el-dialog {
    /deep/.el-icon-view:before {
      display: none;
    }
  }
  /deep/.el-select {
    width: 100%;
  }
}
</style>
